import React, { Component } from "react";
import axios from "axios";
import Serverurl from "./Apiurl";
import {
  Typography,
  Box,
  IconButton,
  Button,
  Card,
  CardContent,
  List,
  ListItem,
  ListItemText,
  Collapse,
  Alert,
  CardActionArea,
  Dialog,
  DialogTitle,
  DialogContent,
  TextField,
} from "@mui/material";
import AddIcon from "@mui/icons-material/Add";
import DeleteIcon from "@mui/icons-material/Delete";
import CloseIcon from "@mui/icons-material/Close";
import SlidingPane from "react-sliding-pane";
import Quotecustomers from "./Quotecustomers";
import Quoteproducts from "./Quoteproducts";
import Quoteothercharges from "./Quoteothercharges";
import Quotetermsconditions from "./Quotetermsconditions";
import { useNavigate } from "react-router-dom";
import ArrowBackIcon from "@mui/icons-material/ArrowBack";

import ChevronLeftIcon from "@mui/icons-material/ChevronLeft";
class Makequote extends Component {
  constructor(props) {
    super(props);
    this.state = {
      sliderOpen: false,
      sliderType: null,
      latestQuote: null,
      selectedCustomers: [],
      selectedProducts: [],
      otherCharges: [],
      selectedTerms: [],
      showError: false,
      errorMsg: "",
      openOtherChargeDialog: false,
      otc_id: 0,
      otc_title: "",
      otc_price: "",
      otc_tax: "0",
      isTaxable: false,
      erropen: false,
      errormessage: "",
      btndisabled: false,
      submitbtn: "Add",
      showTopError: false,
      topErrorMessage: "",
      otherChargeError: false,
      showPdf: false,
      savedQuoteId: null,
      quotationNo: "",
      tc_type: "1",
      editProductOpen: false,
      editProduct: null,
      productDialogMode: "",
      mode: "",
      qu_id: 0,
      old_qu_id: 0,
      date: "",
      qu_qunumber: "",
      GSTDisplay: "YES",
      HSNDisplay: "YES",
      SignatureDisplay: "YES",
      editingOtherChargeId: null,
    };
  }

  componentDidMount() {
    if (localStorage.getItem("GBuserid") === null) {
      this.setState({ redirect: true, pagename: "/Businesslogin" });
      return;
    }
localStorage.removeItem("selectedCustomers");
        localStorage.removeItem("selectedProducts");
        localStorage.removeItem("selectedTerms");
        localStorage.removeItem("otherCharges");
    this.fetchLatestQuote();
    this.fetchQuotationSettings();

    const editId = this.getParameterByName("edit");
    const duplicateId = this.getParameterByName("duplicate");

    if (editId) {
      this.setState({ mode: "edit" });
      this.getQuoteDetails(editId);
    } else if (duplicateId) {
      this.setState({ mode: "duplicate" });
      this.fetchQuotationNo();
      this.getQuoteDetails(duplicateId);
    } else {
      this.fetchQuotationNo();

      const localTerms = JSON.parse(localStorage.getItem("selectedTerms")) || [];
      const filteredTerms = localTerms.filter((t) => String(t.tc_type) === "1");

      this.setState({
        selectedCustomers: JSON.parse(localStorage.getItem("selectedCustomers")) || [],
        selectedProducts: JSON.parse(localStorage.getItem("selectedProducts")) || [],
        selectedTerms: filteredTerms,
        otherCharges: JSON.parse(localStorage.getItem("otherCharges")) || [],
      });
    }
  }

  getParameterByName(name, url) {
    let targetUrl = url || window.location.href;
    targetUrl = targetUrl.toLowerCase();
    const cleanName = name.replace(/[[\]]/g, "\\$&").toLowerCase();
    const regex = new RegExp("[?&]" + cleanName + "(=([^&#]*)|&|#|$)");
    const results = regex.exec(targetUrl);
    if (!results) return null;
    if (!results[2]) return "";
    return decodeURIComponent(results[2].replace(/\+/g, " "));
  }

  fetchQuotationSettings = () => {
    const bu_id = localStorage.getItem("GBuserid");

    axios.get(Serverurl + "ajaxadminoption.php?action=getdata&ao_bu_id=" + bu_id + "&ao_name=quotation").then((res) => {
      if (res.data && res.data.length > 0) {
        const arr = (res.data[0].ao_value || "").split("~");
        this.setState({ GSTDisplay: arr[2] || "YES", HSNDisplay: arr[3] || "YES", SignatureDisplay: arr[6] || "YES" });
      }
    });
  };

  getQuoteDetails = (id) => {
    axios.get(Serverurl + "ajaxquotation.php?action=getall&qu_id=" + id).then((res) => {
      if (!res.data || !res.data[0]) return;

      let data = res.data[0];
      let loadedOtherCharges = [];

      if (data.qu_otc_title) {
        const titles = data.qu_otc_title.split(",");
        const prices = data.qu_otc_price ? data.qu_otc_price.split(",") : [];
        const taxes = data.qu_otc_tax ? data.qu_otc_tax.split(",") : [];

        loadedOtherCharges = titles.map((title, index) => ({
          id: Date.now() + index,
          qu_otc_title: title.trim(),
          qu_otc_price: prices[index] ? prices[index].trim() : "0",
          qu_otc_tax: taxes[index] ? taxes[index].trim() : "0",
          isTaxable: Number(taxes[index]) > 0,
        }));
      }

      const updatedState = { old_qu_id: id, qu_id: id, date: data.qu_date, otherCharges: loadedOtherCharges };

      if (this.state.mode === "edit" && data.qu_qunumber) {
        updatedState.qu_qunumber = data.qu_qunumber;
        updatedState.quotationNo = data.qu_qunumber;
      }

      this.setState(updatedState);

      if (data.qu_cu_id) this.getCustomer(data.qu_cu_id);
      this.getPurchaseProducts(id);
      if (data.qu_termsandconditions) this.getTerms(data.qu_termsandconditions);
    });
  };

  getCustomer = (cu_id) => {
    axios.get(Serverurl + "ajaxcustomer.php?action=getall&cu_id=" + cu_id).then((res) => {
      if (Array.isArray(res.data)) {
        this.setState({ selectedCustomers: res.data });
      }
    });
  };

  getTerms = (tc_ids) => {
    axios.get(Serverurl + "ajaxtermsconditions.php?action=getall&tc_type=1").then((res) => {
      if (Array.isArray(res.data)) {
        const idsArray = String(tc_ids).split(",").map((id) => id.trim());
        const matchedTerms = res.data.filter((item) => idsArray.includes(String(item.tc_id)));
        this.setState({ selectedTerms: matchedTerms });
      }
    });
  };

  getPurchaseProducts = (qu_id) => {
    axios.get(Serverurl + "ajaxquotationproducts.php?action=getall&qp_qu_id=" + qu_id).then((res) => {
      if (Array.isArray(res.data)) {
        this.setState({
          selectedProducts: res.data.map((item) => ({
            pr_id: item.qp_pr_id,
            pr_name: item.pr_name,
            pr_price: item.qp_price,
            pr_gst: item.pr_gst,
            pr_description: item.pr_description,
            pr_hsncode: item.pr_hsncode || "",
            qp_quantity: item.qp_quantity,
            qp_totalprice: item.qp_totalprice,
            qp_id: item.qp_id || 0,
          })),
        });
      }
    });
  };

  fetchLatestQuote = () => {
    axios.get(Serverurl + "ajaxquotation.php?action=getall").then((res) => {
      if (Array.isArray(res.data) && res.data.length > 0) {
        const latest = res.data.reduce((prev, curr) => Number(prev.qu_id) > Number(curr.qu_id) ? prev : curr);
        this.setState({ latestQuote: latest });
      }
    });
  };

  fetchQuotationNo = () => {
    const bu_id = localStorage.getItem("GBuserid");
    if (!bu_id) return;

    axios.get(Serverurl + "ajaxadminoption.php?action=getdata&&ao_bu_id=" + bu_id + "&ao_name=quotation").then((res) => {
      if (Array.isArray(res.data) && res.data.length > 0) {
        const data = res.data[0];
        const arr = data.ao_value.split("~");
        const prefix = arr[0] || "QU";
        const rawNumber = arr[1] || "";

        this.setState({ quotationNo: `${prefix}-${rawNumber}`, qu_qunumber: rawNumber });
      } else {
        this.setState({ quotationNo: "", qu_qunumber: "" });
      }
    });
  };

  openSlider = (type) => this.setState({ sliderOpen: true, sliderType: type });

  closeSlider = () => this.setState({ sliderOpen: false, sliderType: null });

  addCustomerToQuote = (customer) => {
    const alreadyExists = this.state.selectedCustomers.some((item) => String(item.cu_id) === String(customer.cu_id));

    if (alreadyExists) {
      this.setState({ showTopError: true, topErrorMessage: "Customer already exists" });
      return;
    }

    const updated = [...this.state.selectedCustomers, customer];

    localStorage.setItem("selectedCustomers", JSON.stringify(updated));
    this.setState({ selectedCustomers: updated });
  };

  openProductForAdd = (product) => {
    const alreadyExists = this.state.selectedProducts.some((item) => String(item.pr_id) === String(product.pr_id));

    if (alreadyExists) {
      this.setState({ showTopError: true, topErrorMessage: "Product already exists" });
      return;
    }

    const newProduct = {
      ...product,
      pr_price: product.pr_price || 0,
      pr_gst: product.pr_gst || 0,
      pr_hsncode: product.pr_hsncode || "",
      qp_quantity: 1,
    };

    this.setState({ editProductOpen: true, editProduct: newProduct, productDialogMode: "add" });
  };

  openProductForEdit = (product) => {
    this.setState({ editProductOpen: true, editProduct: { ...product }, productDialogMode: "edit" });
  };

  saveProductFromDialog = () => {
    if (!this.state.editProduct) return;

    const product = {
      ...this.state.editProduct,
      pr_price: Number(this.state.editProduct.pr_price) || 0,
      pr_gst: Number(this.state.editProduct.pr_gst) || 0,
      pr_hsncode: this.state.editProduct.pr_hsncode || "",
      qp_quantity: Number(this.state.editProduct.qp_quantity) || 1,
    };

    let updatedProducts;

    if (this.state.productDialogMode === "add") {
      const exists = this.state.selectedProducts.some((p) => String(p.pr_id) === String(product.pr_id));

      if (exists) {
        this.setState({ showTopError: true, topErrorMessage: "Product already exists", editProductOpen: false, editProduct: null, productDialogMode: "" });
        return;
      }

      updatedProducts = [...this.state.selectedProducts, product];
    } else {
      updatedProducts = this.state.selectedProducts.map((p) => String(p.pr_id) === String(product.pr_id) ? product : p);
    }

    localStorage.setItem("selectedProducts", JSON.stringify(updatedProducts));

    this.setState({
      selectedProducts: updatedProducts,
      editProductOpen: false,
      editProduct: null,
      productDialogMode: "",
      erropen: false,
      errormessage: "",
    });
  };

  cancelProductDialog = () => {
    this.setState({ editProductOpen: false, editProduct: null, productDialogMode: "" });
  };

  addTermToQuote = (term) => {

    if (String(term.tc_type) !== "1") {
      this.showError("Only quotation terms and conditions (Type 1) can be added.");
      return;
    }

    const exists = this.state.selectedTerms.some((t) => String(t.tc_id) === String(term.tc_id));

    if (exists) {
      this.setState({ showTopError: true, topErrorMessage: "Term already exists" });
      this.closeSlider();
      return;
    }

    const updated = [...this.state.selectedTerms, term];

    localStorage.setItem("selectedTerms", JSON.stringify(updated));
    this.setState({ selectedTerms: updated });
  };

  removeCustomer = (id) => {
	   let r = window.confirm("Do you really want to Delete?");
		 if(r === true){
    const updated = this.state.selectedCustomers.filter((c) => c.cu_id !== id);
    localStorage.setItem("selectedCustomers", JSON.stringify(updated));
    this.setState({ selectedCustomers: updated });
		 }
  };

  removeProduct = (id) => {
	   let r = window.confirm("Do you really want to Delete?");
		 if(r === true){
    const updated = this.state.selectedProducts.filter((p) => p.pr_id !== id);
    localStorage.setItem("selectedProducts", JSON.stringify(updated));
    this.setState({ selectedProducts: updated });
		 }
  };

  removeTerm = (id) => {
	   let r = window.confirm("Do you really want to Delete?");
		 if(r === true){
    const updated = this.state.selectedTerms.filter((t) => t.tc_id !== id);
    localStorage.setItem("selectedTerms", JSON.stringify(updated));
    this.setState({ selectedTerms: updated });
		 }
  };

  removeOtherCharge = (id) => {
	   let r = window.confirm("Do you really want to Delete?");
		 if(r === true){
    const updated = this.state.otherCharges.filter((o) => o.id !== id);
    localStorage.setItem("otherCharges", JSON.stringify(updated));
    this.setState({ otherCharges: updated });
		 }
  };

  openOtherChargeDialog = () => this.setState({ openOtherChargeDialog: true });

  closeOtherChargeDialog = () => this.setState({ openOtherChargeDialog: false });

  myChangeHandler = (e) => {
    this.setState({ [e.target.name]: e.target.value });
  };

  showError = (msg) => {
    this.setState({ erropen: true, errormessage: msg });
  };

  handleSubmit = () => {
    if (!this.state.otc_title.trim()) return this.showError("Please Enter Title");
    if (!this.state.otc_price.trim()) return this.showError("Please Enter Price");

    const chargeData = {
      qu_otc_title: this.state.otc_title,
      qu_otc_price: this.state.otc_price,
      qu_otc_tax: this.state.isTaxable ? this.state.otc_tax : "0",
      isTaxable: this.state.isTaxable,
    };

    let updated;

    if (this.state.editingOtherChargeId !== null) {
      updated = this.state.otherCharges.map((charge) => charge.id === this.state.editingOtherChargeId ? { ...charge, ...chargeData } : charge);
    } else {
      const newCharge = { id: Date.now(), ...chargeData };
      updated = [...this.state.otherCharges, newCharge];
    }

    localStorage.setItem("otherCharges", JSON.stringify(updated));

    this.setState({
      otherCharges: updated,
      otc_id: 0,
      otc_title: "",
      otc_price: "",
      otc_tax: "0",
      isTaxable: false,
      editingOtherChargeId: null,
      openOtherChargeDialog: false,
      erropen: false,
      errormessage: "",
    });
  };

  handleTaxableChange = (e) => {
    this.setState({ isTaxable: e.target.checked, otc_tax: "0" });
  };

  calculateProductTotals = () => {
    let subtotal = 0;
    let gst = 0;

    this.state.selectedProducts.forEach((p) => {
      const qty = Number(p.qp_quantity || p.qty || 1);
      const price = Number(p.pr_price) || 0;
      const tax = Number(p.pr_gst) || 0;
      const lineTotal = price * qty;

      subtotal += lineTotal;
      gst += (lineTotal * tax) / 100;
    });

    return { subtotal, gst };
  };

  calculateOtherChargesTotals = () => {
    let subtotal = 0;
    let gst = 0;

    this.state.otherCharges.forEach((o) => {
      const price = Number(o.qu_otc_price) || 0;
      const tax = Number(o.qu_otc_tax) || 0;

      subtotal += price;
      gst += (price * tax) / 100;
    });

    return { subtotal, gst };
  };

  handleErrorclose = () => this.setState({ erropen: false, errormessage: "" });

  prepareQuotationProducts = () => {
    return this.state.selectedProducts.map((p) => {
      const qty = Number(p.qp_quantity || p.qty || 1);
      const price = Number(p.pr_price);
      const total = qty * price;
      const qp_id = p.qp_id || 0;

      return `${p.pr_id}~${qty}~${price}~${total}~${qp_id}`;
    }).join(";");
  };

  validateQuote = () => {
   if (!this.state.selectedCustomers.length) {
    window.scrollTo({ top: 0, behavior: "smooth" });
    return "Please Select a Customer";
  }

  if (!this.state.selectedProducts.length) {
    window.scrollTo({ top: 0, behavior: "smooth" });
    return "Please Select At Least One Product";
  }

  if (!this.state.selectedTerms.length) {
    window.scrollTo({ top: 0, behavior: "smooth" });
    return "Please Select Terms & Conditions";
  }
  return null;
  };

  saveQuotation = () => {
    const error = this.validateQuote();

    if (error) {
      this.setState({ showTopError: true, topErrorMessage: error });
      return;
    }

    const quotationProducts = this.prepareQuotationProducts();
    const productTotals = this.calculateProductTotals();
    const otherTotals = this.calculateOtherChargesTotals();

    const grandTotal = productTotals.subtotal + productTotals.gst + otherTotals.subtotal + otherTotals.gst;

    const otcTitles = this.state.otherCharges.map((o) => o.qu_otc_title).join(",");
    const otcPrices = this.state.otherCharges.map((o) => o.qu_otc_price).join(",");
    const otcTaxes = this.state.otherCharges.map((o) => o.qu_otc_tax).join(",");

    const qu_id = this.state.mode === "edit" ? this.state.qu_id : 0;
    const bu_id = localStorage.getItem("GBuserid");

    const formdata = new FormData();

    formdata.append("action", "poinsertorupdate");
    formdata.append("qu_id", qu_id);
    formdata.append("qu_cu_id", this.state.selectedCustomers[0].cu_id);
    formdata.append("qu_qunumber", this.state.qu_qunumber || "");
    formdata.append("qu_termsandconditions", this.state.selectedTerms.map((t) => t.tc_id).join(","));
    formdata.append("qu_roundofamount", grandTotal.toFixed(2));
    formdata.append("qu_bu_id", bu_id);
    formdata.append("qu_sessionid", 1);
    formdata.append("qu_type", 1);
    formdata.append("v_quotationproducts", quotationProducts);
    formdata.append("userid", bu_id);
    formdata.append("qu_otc_title", otcTitles);
    formdata.append("qu_otc_price", otcPrices);
    formdata.append("qu_otc_tax", otcTaxes);

   axios.post(Serverurl + "ajaxquotation.php", formdata).then((res) => {
  console.log("API RESPONSE:", res.data);
  console.log("API RESPONSE TYPE:", typeof res.data);

  let responseData = res.data;

  if (typeof responseData === "string") {
    try {
      responseData = JSON.parse(responseData);
    } catch (e) {
      console.error("JSON PARSE ERROR:", e);
      alert("Invalid server response");
      return;
    }
  }

  if (responseData.status === "success" && responseData.qu_id) {
    const quoteId = responseData.qu_id;

    localStorage.removeItem("selectedCustomers");
    localStorage.removeItem("selectedProducts");
    localStorage.removeItem("selectedTerms");
    localStorage.removeItem("otherCharges");

    this.props.navigate("/quotation/view/" + quoteId);
  } else {
    console.error("SAVE RESPONSE:", responseData);
    alert("Quotation ID missing or save failed");
  }
}).catch((error) => {
  console.error("SAVE ERROR:", error);
  alert("Save failed");
});

  };

  openOtherChargeForEdit = () => {
    const charges = this.state.otherCharges;

    if (charges.length === 0) {
      this.setState({
        openOtherChargeDialog: true,
        editingOtherChargeId: null,
        otc_id: 0,
        otc_title: "",
        otc_price: "",
        otc_tax: "0",
        isTaxable: false,
        erropen: false,
        errormessage: "",
      });

      return;
    }

    const charge = charges[0];

    this.setState({
      openOtherChargeDialog: true,
      editingOtherChargeId: charge.id,
      otc_id: charge.id,
      otc_title: charge.qu_otc_title || "",
      otc_price: charge.qu_otc_price || "",
      otc_tax: charge.qu_otc_tax || "0",
      isTaxable: Number(charge.qu_otc_tax) > 0,
      erropen: false,
      errormessage: "",
    });
  };

  editOtherCharge = (charge) => {
    this.setState({
      openOtherChargeDialog: true,
      editingOtherChargeId: charge.id,
      otc_id: charge.id,
      otc_title: charge.qu_otc_title || "",
      otc_price: charge.qu_otc_price || "",
      otc_tax: charge.qu_otc_tax || "0",
      isTaxable: Number(charge.qu_otc_tax) > 0,
      erropen: false,
      errormessage: "",
    });
  };

  render() {
    const productTotals = this.calculateProductTotals();
    const otherTotals = this.calculateOtherChargesTotals();
    const grandTotal = productTotals.subtotal + productTotals.gst + otherTotals.subtotal + otherTotals.gst;

    return (
      <Box sx={{ p: 3 }}>
        <Collapse in={this.state.showTopError} sx={{ mb: 2 }}>
          <Alert severity="error" action={<IconButton size="small" onClick={() => this.setState({ showTopError: false })}><CloseIcon fontSize="inherit" /></IconButton>}>
            {this.state.topErrorMessage}
          </Alert>
        </Collapse>

        <Box
  sx={{
    display: "flex",
    justifyContent: "space-between",
    alignItems: "center",
    mb: 2,
    marginBottom: "10px",
    padding: "0px 5px",
  }}
>
  {/* LEFT SIDE - BACK ARROW + QUOTE DATE */}
  <Box
    sx={{
      display: "flex",
      alignItems: "center",
      gap: 1.5,
    }}
  >
  <ChevronLeftIcon
  className="global-back-arrow"
  onClick={() => window.history.back()}
/>

    <Box>
      <Typography
        sx={{
          fontSize: "20px",
          color: "#444",
          lineHeight: 1.3,
        }}
      >
        Quote Date
      </Typography>

      <Typography
        sx={{
          fontSize: "20px",
          color: "#444",
          lineHeight: 1.3,
          mt: 0.5,
        }}
      >
        {this.state.date ||
          new Date().toLocaleDateString("en-GB").replace(/\//g, "-")}
      </Typography>
    </Box>
  </Box>

  {/* RIGHT SIDE - QUOTE NUMBER */}
  {this.state.quotationNo && (
    <Box
      sx={{
        textAlign: "right",
        paddingRight: "5px",
      }}
    >
      <Typography
        sx={{
          fontSize: "20px",
          color: "#444",
          lineHeight: 1.3,
        }}
      >
        Quote No
      </Typography>

      <Typography
        sx={{
          fontSize: "20px",
          color: "#444",
          lineHeight: 1.3,
          mt: 0.5,
        }}
      >
        {this.state.quotationNo}
      </Typography>
    </Box>
  )}
</Box>

        {/* CUSTOMER */}
        <Card sx={{ mb: 2 }}>
          <CardActionArea onClick={() => this.openSlider("customer")}>
            <CardContent sx={{ display: "flex", justifyContent: "space-between", alignItems: "center" }}>
              <Typography variant="h6">Customer</Typography>
             <IconButton
  sx={{
    width: "35px",
    height: "34px",
    backgroundColor: "#11408f",
    color: "#fff",
    borderRadius: "18px",
    "&:hover": {
      backgroundColor: "#cbd5e1",
    },
  }}
>
  <AddIcon sx={{ fontSize: "20px" }} />
</IconButton>
            </CardContent>
          </CardActionArea>
        </Card>

        <List>
          {this.state.selectedCustomers.map((c) => (
            <ListItem key={c.cu_id} secondaryAction={<IconButton onClick={() => this.removeCustomer(c.cu_id)}><DeleteIcon color="error" /></IconButton>}>
              <ListItemText primary={c.cu_name} secondary={c.cu_companyname} />
            </ListItem>
          ))}
        </List>

        {/* PRODUCTS */}
        <Card sx={{ mb: 2 }}>
          <CardActionArea onClick={() => this.openSlider("product")}>
            <CardContent sx={{ display: "flex", justifyContent: "space-between", alignItems: "center" }}>
              <Typography variant="h6">Products</Typography>
                 <IconButton
  sx={{
    width: "35px",
    height: "34px",
    backgroundColor: "#11408f",
    color: "#fff",
    borderRadius: "18px",
    "&:hover": {
      backgroundColor: "#cbd5e1",
    },
  }}
>
  <AddIcon sx={{ fontSize: "20px" }} />
</IconButton>
            </CardContent>
          </CardActionArea>
        </Card>

        <List>
          {this.state.selectedProducts.map((p) => (
            <ListItem key={p.pr_id} onClick={() => this.openProductForEdit(p)} sx={{ cursor: "pointer" }} secondaryAction={<IconButton onClick={(e) => { e.stopPropagation(); this.removeProduct(p.pr_id); }}><DeleteIcon color="error" /></IconButton>}>
              <ListItemText primary={p.pr_name} secondary={
                <>
                  ₹{p.pr_price}
                  {this.state.HSNDisplay === "YES" && <> | HSN: {p.pr_hsncode}</>}
                  {this.state.GSTDisplay === "YES" && <> | GST: {p.pr_gst}%</>}
                </>
              } />
            </ListItem>
          ))}
        </List>

        {/* OTHER CHARGES */}
        <Card sx={{ mb: 2 }}>
          <CardActionArea onClick={this.openOtherChargeForEdit}>
            <CardContent sx={{ display: "flex", justifyContent: "space-between" }}>
              <Typography variant="h6">Other Charges</Typography>
              <IconButton
  sx={{
    width: "35px",
    height: "34px",
    backgroundColor: "#11408f",
    color: "#fff",
    borderRadius: "18px",
    "&:hover": {
      backgroundColor: "#cbd5e1",
    },
  }}
>
  <AddIcon sx={{ fontSize: "20px" }} />
</IconButton>
            </CardContent>
          </CardActionArea>
        </Card>

        <List>
          {this.state.otherCharges.map((o) => (
            <ListItem key={o.id} secondaryAction={<IconButton onClick={(e) => { e.stopPropagation(); this.removeOtherCharge(o.id); }}><DeleteIcon color="error" /></IconButton>} onClick={() => this.editOtherCharge(o)} sx={{ cursor: "pointer" }}>
              <ListItemText primary={o.qu_otc_title} secondary={`₹${o.qu_otc_price} | Tax:${o.qu_otc_tax}%`} />
            </ListItem>
          ))}
        </List>

        {/* TERMS */}
        <Card sx={{ mb: 2 }}>
          <CardActionArea onClick={() => this.openSlider("terms")}>
            <CardContent sx={{ display: "flex", justifyContent: "space-between" }}>
              <Typography variant="h6">Terms & Conditions</Typography>
                 <IconButton
  sx={{
    width: "35px",
    height: "34px",
    backgroundColor: "#11408f",
    color: "#fff",
    borderRadius: "18px",
    "&:hover": {
      backgroundColor: "#cbd5e1",
    },
  }}
>
  <AddIcon sx={{ fontSize: "20px" }} />
</IconButton>
            </CardContent>
          </CardActionArea>
        </Card>

        <List>
          {this.state.selectedTerms.map((t) => (
            <ListItem key={t.tc_id} secondaryAction={<IconButton onClick={() => this.removeTerm(t.tc_id)}><DeleteIcon color="error" /></IconButton>}>
              <ListItemText primary={t.tc_title} secondary={<span dangerouslySetInnerHTML={{ __html: t.tc_content }} />} />
            </ListItem>
          ))}
        </List>

        {/* SUMMARY */}
        {(this.state.selectedProducts.length > 0 || this.state.otherCharges.length > 0) && (
          <Card sx={{ mt: 3, p: 2 }}>
            <Typography variant="h6">Summary</Typography>

            <Box sx={{ display: "flex", justifyContent: "space-between", mt: 1 }}>
              <Typography>Products Subtotal</Typography>
              <Typography>₹{productTotals.subtotal.toFixed(2)}</Typography>
            </Box>

            {this.state.GSTDisplay === "YES" && (
              <Box sx={{ display: "flex", justifyContent: "space-between" }}>
                <Typography>Products GST</Typography>
                <Typography>₹{productTotals.gst.toFixed(2)}</Typography>
              </Box>
            )}

            <Box sx={{ display: "flex", justifyContent: "space-between", mt: 1 }}>
              <Typography>Other Charges</Typography>
              <Typography>₹{otherTotals.subtotal.toFixed(2)}</Typography>
            </Box>

            <Box sx={{ display: "flex", justifyContent: "space-between" }}>
              <Typography>Other Charges GST</Typography>
              <Typography>₹{otherTotals.gst.toFixed(2)}</Typography>
            </Box>

            <Box sx={{ display: "flex", justifyContent: "space-between", mt: 2 }}>
              <Typography variant="h6">Grand Total</Typography>
              <Typography variant="h6">₹{grandTotal.toFixed(2)}</Typography>
            </Box>
          </Card>
        )}

        {/* SAVE */}
        <Box sx={{ display: "flex", 
		justifyContent: "center", mt: 3 }}>
          <Button variant="contained" className="primartybtn" onClick={this.saveQuotation}    sx={{
      borderRadius: "20px",
      padding: "10px 20px",
    }}>Save Quotation</Button>
        </Box>

        {/* SLIDING PANES */}
        <SlidingPane
          isOpen={this.state.sliderOpen}
          from="right"
          width="100%"
          title={this.state.sliderType === "customer" ? "Select Customer" : this.state.sliderType === "product" ? "Select Product" : this.state.sliderType === "othercharges" ? "Select Other Charges" : "Select Terms"}
          onRequestClose={this.closeSlider}
        >
          {this.state.sliderType === "customer" && (
            <Quotecustomers onBack={() => this.closeSlider()} onSelectCustomer={(c) => { this.addCustomerToQuote(c); this.closeSlider(); }} />
          )}

          {this.state.sliderType === "product" && (
            <Quoteproducts onBack={() => this.closeSlider()} onSelectProduct={(p) => { this.closeSlider(); this.openProductForAdd(p); }} />
          )}

          {this.state.sliderType === "othercharges" && (
            <Quoteothercharges
              onSelect={(o) => {
                const exists = this.state.otherCharges.some((x) => x.id === o.otc_id);
                if (exists) return;

                const formatted = {
                  id: o.otc_id,
                  qu_otc_title: o.otc_title,
                  qu_otc_price: o.otc_price,
                  qu_otc_tax: o.otc_tax,
                  isTaxable: Number(o.otc_tax) > 0,
                };

                const updated = [...this.state.otherCharges, formatted];

                localStorage.setItem("otherCharges", JSON.stringify(updated));
                this.setState({ otherCharges: updated });
                this.closeSlider();
              }}
              onAddNew={() => { this.closeSlider(); this.openOtherChargeDialog(); }}
            />
          )}

          {this.state.sliderType === "terms" && (
            <Quotetermsconditions onBack={() => this.closeSlider()} tc_type="1" onSelectTerms={(t) => { this.addTermToQuote(t); this.closeSlider(); }} />
          )}
        </SlidingPane>

        {/* OTHER CHARGE DIALOG */}
        <Dialog open={this.state.openOtherChargeDialog} onClose={this.closeOtherChargeDialog} maxWidth="sm" sx={{ marginBottom: "10px" }} fullWidth
			PaperProps={{
    sx: {
      backgroundColor: "#f0f4f7"
    }
  }}>
          <DialogTitle>Other Charges</DialogTitle>

          <DialogContent sx={{ marginBottom: "10px", padding: "0px 10px" }}>
            <Collapse in={this.state.erropen} sx={{ mb: 2 }}>
              <Alert severity="error" action={<IconButton aria-label="close" size="small" onClick={this.handleErrorclose}><CloseIcon fontSize="inherit" /></IconButton>}>
                {this.state.errormessage}
              </Alert>
            </Collapse>

          
            <p><TextField label="Title" name="otc_title"  placeholder="Title" value={this.state.otc_title} onChange={this.myChangeHandler} InputLabelProps={{ shrink: true }} fullWidth 
			sx={{
      "& .MuiOutlinedInput-root": {
        borderRadius: "10px",
		padding: "4px 0px"
      },
    }}/></p>

           
            <p><TextField  label="Price" name="otc_price"  placeholder="Price" value={this.state.otc_price} type="number" onChange={this.myChangeHandler} InputLabelProps={{ shrink: true }} fullWidth 
			sx={{
      "& .MuiOutlinedInput-root": {
        borderRadius: "10px",
		padding: "4px 0px"
      },
    }}/></p>

            <Box sx={{ display: "flex", alignItems: "center", mt: 1 }}>
              <p><input type="checkbox" checked={this.state.isTaxable} onChange={this.handleTaxableChange} /></p>
              <Typography sx={{ ml: 1 }}>Is Taxable</Typography>
            </Box>

            {this.state.isTaxable && (
              <>
                <p sx={{ mt: 2 }}>Tax %</p>
                <p>
                  <TextField name="otc_tax" value={this.state.otc_tax} type="number" onChange={this.myChangeHandler} fullWidth inputProps={{ maxLength: 2, max: 99, min: 0 }} />
                </p>
              </>
            )}

            <div className="actionbuttons">
              <div className="cancelbtn">
                <Button variant="contained" className="secondarybtn" onClick={this.closeOtherChargeDialog}>Cancel</Button>
              </div>

              <div className="savebtn">
                <Button variant="contained" className="primartybtn" onClick={this.handleSubmit}>{this.state.editingOtherChargeId !== null ? "Save" : "Add"}</Button>
              </div>

              <div className="clear"></div>
            </div>
          </DialogContent>
        </Dialog>

        {/* PRODUCT DETAILS DIALOG */}
        <Dialog open={this.state.editProductOpen} onClose={this.cancelProductDialog} maxWidth="sm" fullWidth
		PaperProps={{
    sx: {
      backgroundColor: "#f0f4f7"
    }
  }}>
          <DialogTitle sx={{ padding: "5px 10px" }}>Product Details</DialogTitle>

          <DialogContent sx={{ padding: "0px 8px" }}>
            {this.state.editProduct && (
              <>
                <TextField placeholder="Product Name" value={this.state.editProduct.pr_name || ""} fullWidth margin="normal" disabled
sx={{
      "& .MuiOutlinedInput-root": {
        borderRadius: "10px",
		padding: "4px 0px"
      },
    }}				/>

                <TextField
                  placeholder="Price"
                  name="pr_price"
                  type="number"
                  value={this.state.editProduct.pr_price ?? ""}
                  onChange={(e) => this.setState({ editProduct: { ...this.state.editProduct, pr_price: e.target.value } })}
                  fullWidth
                  margin="normal"
				  sx={{
      "& .MuiOutlinedInput-root": {
        borderRadius: "10px",
		padding: "4px 0px"
      },
    }}
                />

                <TextField
                  placeholder="GST %"
                  name="pr_gst"
                  type="number"
                  value={this.state.editProduct.pr_gst ?? ""}
                  inputProps={{ maxLength: 2, min: 0, max: 99, inputMode: "numeric" }}
                  onChange={(e) => this.setState({ editProduct: { ...this.state.editProduct, pr_gst: e.target.value } })}
                  fullWidth
                  margin="normal"
				  sx={{
      "& .MuiOutlinedInput-root": {
        borderRadius: "10px",
		padding: "4px 0px"
      },
    }}
                />

                <TextField
                  placeholder="HSN Code"
                  name="pr_hsncode"
                  value={this.state.editProduct.pr_hsncode || ""}
                  onChange={(e) => this.setState({ editProduct: { ...this.state.editProduct, pr_hsncode: e.target.value } })}
                  fullWidth
                  margin="normal"
				  sx={{
      "& .MuiOutlinedInput-root": {
        borderRadius: "10px",
		padding: "4px 0px"
      },
    }}
                />
              </>
            )}

            <div className="actionbuttons">
              <div className="cancelbtn">
                <Button variant="contained" className="secondarybtn" onClick={this.cancelProductDialog}>Cancel</Button>
              </div>

              <div className="savebtn">
                <Button variant="contained" className="primartybtn" onClick={this.saveProductFromDialog}>{this.state.productDialogMode === "add" ? "Add" : "Save"}</Button>
              </div>

              <div className="clear"></div>
            </div>
          </DialogContent>
        </Dialog>
      </Box>
    );
  }
}

function MakequoteWithNavigate(props) {
  const navigate = useNavigate();
  return <Makequote {...props} navigate={navigate} />;
}

export default MakequoteWithNavigate;
